class SectionEditorialTiles extends HTMLElement {
  constructor() {
    super();

    this.card = this.querySelector(".editorial-tiles__card");

    if (!this.card) return;

    this.cards = [...this.querySelectorAll("[data-card]")];
    this.tileTextWraps = this.querySelectorAll("[data-tile-text-wrap]");
    this.defaultHref = this.card.href;
    this.tileText = this.querySelector("[data-tile-text]");
    this.toggleButton = this.querySelector("[data-toggle-btn]");
  }

  connectedCallback() {
    if (!this.card) return;

    this.cards.forEach((card) => {
      card.addEventListener("mouseenter", () => {
        this._updateText(card);
      });

      card.addEventListener("touchstart", () => {
        console.log("?");
        this._updateText(card);
      });

      card.addEventListener("focusin", () => {
        this._updateText(card);
      });
    });

    this.addEventListener("mouseleave", () => {
      this._hideText();
    });

    this.addEventListener("focusout", (e) => {
      if (this.contains(e.relatedTarget)) return;

      this._hideText();
      this._toggleButton();
    });

    this.toggleButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      this._toggleButton();
    });
  }

  disconnectedCallback() {}

  _toggleButton() {
    if (!this.toggleButton.classList.contains("is-active")) {
      this.toggleButton.classList.add("is-active");
      this.cards.forEach((card) => {
        this._updateText(card);
      });
    } else {
      this.toggleButton.classList.remove("is-active");
      this._hideText();
    }
  }

  _updateText(card) {
    this._showText(card.dataset.blockId);
  }

  _showText(blockId) {
    const targetCard = this.querySelector(`[data-text-wrap-id="${blockId}"]`);

    if (!targetCard) return;

    targetCard.style.display = null;
  }

  _hideText() {
    this.tileTextWraps.forEach((tileTextWrap) => {
      tileTextWrap.style.display = "none";
    });
    this.card.href = this.defaultHref;
  }
}

if (!customElements.get("section-editorial-tiles")) {
  customElements.define("section-editorial-tiles", SectionEditorialTiles);
}
